import Loadable from 'react-loadable'
export const findTreeItemFunc = (treeList, findFunc, onChildrenFind) => {
  if (!treeList || findFunc === undefined) return
  const itm = treeList.find(findFunc)
  if (itm) {
    return itm
  } else {
    let findItm = undefined
    for (let i = 0; i < treeList.length; i++) {
      const ele = treeList[i]
      if (ele?.children) {
        findItm = findTreeItemFunc(ele.children, findFunc, onChildrenFind)
        if (findItm) {
          onChildrenFind && onChildrenFind(ele)
        }
      }
      if (findItm) {
        return findItm
      }
    }
    return findItm
  }
}

export const findTreeItem = (treeList, fieldName, value) => {
  if (!treeList || value === undefined) return
  const itm = treeList.find((c) => (c ? c[fieldName] === value : undefined))
  if (itm) {
    return itm
  } else {
    let findItm = undefined
    for (let i = 0; i < treeList.length; i++) {
      const ele = treeList[i]
      if (ele?.children) {
        findItm = findTreeItem(ele.children, fieldName, value)
      }
      if (findItm) {
        return findItm
      }
    }
    return findItm
  }
}

export const treeMap = (treeList, callback) => {
  if (!callback) return treeList
  const rst = []
  if (treeList && treeList.length > 0) {
    treeList.forEach((item, index) => {
      let v = callback(item, index)
      if (v) {
        if (item?.children && item.children.length > 0) {
          v.children = treeMap(item.children, callback)
        }
        rst.push({ ...v })
      }
    })
  }
  return rst
}
//生成 guid
export const guid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export const cloneDeep = (obj) => {
  if (obj === undefined) return undefined
  const objClone = Array.isArray(obj) ? [] : {}
  if (obj && typeof obj === 'object') {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] && typeof obj[key] === 'object') {
          objClone[key] = cloneDeep(obj[key])
        } else {
          objClone[key] = obj[key]
        }
      }
    }
  }
  return objClone
}
export const stringToArrayKey = (string, valueName) => {
  if (!string) return []
  if (string instanceof Array) return string
  const s = string.split(',')
  const rtn = []
  for (let index = 0; index < s.length; index++) {
    const item = s[index]
    if (valueName) {
      const obj = {}
      obj[valueName] = item
      rtn.push(obj)
    } else {
      rtn.push(item)
    }
  }
  return rtn
}
const findFormItemInner = (item, fieldName) => {
  if (item.fieldName == fieldName) {
    return item
  } else if (item.type == 'row' && item.children) {
    for (let j = 0; j < item.children.length; j++) {
      const child = item.children[j]
      if (child.col) {
        const obj = findFormItemInner(child.col, fieldName)
        if (obj) return obj
      }
    }
  }
  return null
}
export const findFormItem = (formItem, fieldName) => {
  //先在最外层找
  const obj = formItem.find((c) => c?.fieldName && c?.fieldName == fieldName)
  if (obj) return obj //找到返回
  //看是否存在row
  const objExistRow = formItem.find((c) => c?.type == 'row')
  if (!objExistRow) return null //没找到row直接返回没找到
  //开始树查找
  for (let i = 0; i < formItem.length; i++) {
    const item = formItem[i]
    const findObj = findFormItemInner(item, fieldName)
    if (findObj) return findObj
  }
  return null
}
export const objToParams = (obj) => {
  if (!obj) return ''
  let rtn = ''
  for (const key in obj) {
    if (key && obj[key] !== undefined && obj[key] !== '' && obj[key] !== null)
      rtn += key + '=' + encodeURIComponent(obj[key]) + '&'
  }
  rtn = rtn.substring(0, rtn.length - 1)
  return rtn
}
export const convertToTree = (list, id, parentField = 'nodePId') => {
  let result = []
  let childList = []
  if (!id) {
    childList = list.filter(
      (c) =>
        c[parentField] == null ||
        list.findIndex((d) => d.id === c[parentField]) < 0
    )
  } else {
    childList = list.filter((x) => x[parentField] == id)
  }
  childList.forEach((item) => {
    let tree = {
      ...item,
      children: convertToTree(list, item.id, parentField),
    }
    result.push(tree)
  })

  return result
}
export function getArrayDifference(arr1, arr2, key) {
  //两个数组的差异部分
  return arr1.filter((item1) => {
    return !arr2.some((item2) => item2[key] === item1[key])
  })
}
//从本地存储中获取对象
export function getLocalStorage(key) {
  const str = localStorage.getItem(key)
  const obj = JSON.parse(str)
  return obj
}
//将对象存储到本地存储
export function setLocalStorage(key, obj) {
  const str = JSON.stringify(obj)
  localStorage.setItem(key, str)
}
export const typeList = [
  //文件上传类型
  {
    key: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    value: 'office/excel',
  },
  {
    key: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    value: 'office/word',
  },
]

export const filterTreeNode = (inputText, node) => {
  return node.props.title.toLowerCase().indexOf(inputText.toLowerCase()) > -1
}

export const filterOption = (inputValue, option) =>
  option?.props?.value?.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0 ||
  option?.props?.children?.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0

import React from 'react'
import { useI18n } from '../hooks/useLocale'
export const InitCardTitle = (title, style, other) => {
  const t = useI18n()
  return (
    <div style={{ display: 'flex' }}>
      <div className="card-head-flag"></div>
      <span style={style}>
        {t(title) ?? title}
        {other}
      </span>
    </div>
  )
}
export function parseQueryString() {
  //将地址栏？后面的参数解析成对象
  if (!window.location.search) {
    return {}
  }
  const queryString = window.location.search.slice(1)
  const params = {}
  if (queryString) {
    const keyValuePairs = queryString.split('&')
    keyValuePairs.forEach((keyValue) => {
      const [key, value] = keyValue.split('=')
      params[key] = decodeURIComponent(value)
    })
  }

  return params
}
export function getFlattenRoutes(routes) {
  const res = []
  function travel(_routes) {
    _routes.forEach((route) => {
      const visibleChildren = (route.children || []).filter(
        (child) => !child.ignore
      )
      if (route.key && (!route.children || !visibleChildren.length)) {
        try {
          if (!route.dynamic) {
            route.component = Loadable({
              loader: () => import(`../pages/${route.path ?? route.key}`),
              loading: <div>...</div>,
            })
          }
          res.push(route)
        } catch (e) {
          console.error(e)
        }
      }
      if (route.children && route.children.length) {
        travel(route.children)
      }
    })
  }
  travel(routes)
  return res
}

export function removeUndefined(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([key, value]) =>
        key !== 'pageSize' &&
        key !== 'pageIndex' &&
        value !== undefined &&
        value.length > 0
    )
  )
}
export function objectToQueryString(obj) {
  return Object.keys(obj)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join('&')
}
export function arraysEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) return false
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false
  }
  return true
}

export const initId = () => {
  return '00000000-0000-0000-0000-000000000000'
}
export const getCardTitle = (title) => {
  return (
    <div style={{ display: 'flex' }}>
      <div className="card-head-flag"></div>
      <span>{title}</span>
    </div>
  )
}
